import request from '@/router/axios';

export const getList = (current, size, params, deptId) => request({
  url: '/api/mcc-worker/teammember/cFactoryList',
  method: 'get',
  params: {
    ...params,
    current,
    size,
    deptId,
  },
})

export const addList = params => request({
  url: '/api/mcc-worker/teammember/cFactory',
  method: 'post',
  data: params,
})

export const turnSite = params => request({
  url: '/api/mcc-worker/teammember/cFactory',
  method: 'post',
  data: params,
})
// 进入转场流程的申请
export const turnSiteFlow = (params, headers) => request({
  url: '/api/mcc-worker/teammember/cFactory',
  method: 'post',
  headers,
  data: params,
})
// 转场流程详情
export const workerDetail = params => request({
  url: '/api/mcc-worker/processfield/detail',
  method: 'get',
  params: {
    ...params,
  },
})

// 转场流程下载接口
export const downLoadTurnSite = params => request({
  url: '/api/mcc-worker/processfield/DaoChuCFPerson',
  method: 'get',
  responseType: 'blob',
  params: {
    formId: '17',
    ...params,
  },
})

// 转场流程全部导出接口
export const downLoadAllTurnSite = params => request({
  url: '/api/mcc-worker/processfield/DaoChuCF',
  method: 'get',
  responseType: 'blob',
  params: {
    formId: '17',
    ...params,
  },
})

// 快速转场
export const getquickTransitionList = (current, size, params) => request({
  url: '/api/mcc-worker/processsimplifytransition/page',
  method: 'get',
  params: {
    ...params,
    current,
    size,
  },
})

// 快速转场记录下载
export const downLoadQuickTransition = params => request({
  url: '/api/mcc-worker/processsimplifytransition/excel',
  method: 'get',
  responseType: 'blob',
  params: {
    ...params,
  },
})

export default {
  getList,
}
